export default __webpack_public_path__ + "static/media/BrainBreak cards94.51f40a72.png";